import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
import FJConfig from '../../config/FJConfig';
import FJAppConstant from '../../constants/FJAppConstant';

export const IMAGE_MANIPULATION_USE_CREDIT = 6;

export const FJSliceImageManipulation = createSlice({
    name: 'imageManipulation',
    initialState: {
        uploadImageInfo: {},
        switchOldPhotoRestoration: FJConfig.appType !== FJAppConstant.PHOTO_COLORIZE,
        switchPhotoColorize: FJConfig.appType === FJAppConstant.PHOTO_COLORIZE,
        selectedColorName: 'natural',
        imageEnhancerData: {
            switch: false,
            imageType: FJConstant.FACE,
            upscale: 2,
        },

        switchScratchOrFold: false,
        downloadEditImageLoading: false,

        scratchRepairMaskUrl: null,
    },
    reducers: {
        setSliceUploadImageInfoAction: (state, action) => {
            state.uploadImageInfo = action.payload;
        },
        setSliceSwitchOldPhotoRestorationAction: (state, action) => {
            state.switchOldPhotoRestoration = action.payload;
        },
        setSliceSwitchPhotoColorizeAction: (state, action) => {
            state.switchPhotoColorize = action.payload;
        },
        setSliceSelectedColorNameAction: (state, action) => {
            state.selectedColorName = action.payload;
        },
        setSliceImageEnhancerDataAction: (state, action) => {
            state.imageEnhancerData = action.payload;
        },
        setSliceSwitchScratchOrFold: (state, action) => {
            state.switchScratchOrFold = action.payload;
        },
        setSliceDownloadEditImageLoading: (state, action) => {
            state.downloadEditImageLoading = action.payload;
        },

        setSliceScratchRepairMaskUrl: (state, action) => {
            state.scratchRepairMaskUrl = action.payload;
        },
    },
});

export const {
    setSliceUploadImageInfoAction,
    setSliceSwitchOldPhotoRestorationAction,
    setSliceSwitchPhotoColorizeAction,
    setSliceSelectedColorNameAction,
    setSliceImageEnhancerDataAction,
    setSliceSwitchScratchOrFold,
    setSliceDownloadEditImageLoading,
    setSliceScratchRepairMaskUrl,
} = FJSliceImageManipulation.actions;

export default FJSliceImageManipulation.reducer;
